import ValidationError from "./ValidationError"

class LinkedInMediaAssetsValidationError extends ValidationError {
    constructor(msg: string) {
        super(msg);

        // Set the prototype explicitly.
        Object.setPrototypeOf(this, LinkedInMediaAssetsValidationError.prototype);
    }

    getErrorMessage() {
        return this.message;
    }
}

export default LinkedInMediaAssetsValidationError;
